import { render } from "./ShippingListOrderView.vue?vue&type=template&id=15d2c3a7"
import script from "./ShippingListOrderView.vue?vue&type=script&lang=js"
export * from "./ShippingListOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__